import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import "../css/Login.css";

const EditVehicle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const server_url = localStorage.getItem("server_url");
  const grage_id = localStorage.getItem("grage_id");
  const company_id = localStorage.getItem("company_id");

  // Get vehicle data from navigation state
  const vehicleData = location.state?.vehicle;

  // Searchable Dropdown Component (same as above)
  const SearchableDropdown = ({
    options = [],
    value,
    onChange,
    placeholder,
    name,
    error,
    loading,
    disabled,
    required,
  }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
      const filtered = options.filter((option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }, [searchTerm, options]);

    useEffect(() => {
      const selected = options.find((opt) => opt.value == value);
      setSearchTerm(selected ? selected.label : "");
    }, [value, options]);

    const handleInputChange = (e) => {
      const term = e.target.value;
      setSearchTerm(term);
      setIsOpen(true);
    };

    const handleSelect = (selectedValue) => {
      setIsOpen(false);
      if (onChange) {
        onChange({ target: { name, value: selectedValue } });
      }
    };

    const displayValue = options.find((opt) => opt.value == value)?.label || "";
    const inputValue = isOpen ? searchTerm : displayValue;

    return (
      <div className="searchable-dropdown" ref={dropdownRef}>
        <div className={`input-group ${error ? "error" : ""}`}>
          <div className="input-icon">
            <i className="fas fa-search"></i>
          </div>
          <input
            type="text"
            className="form-input"
            placeholder={placeholder}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setIsOpen(true)}
            disabled={disabled || loading}
            readOnly={!isOpen}
            required={required}
          />
          {isOpen && (
            <ul
              className="dropdown-list"
              style={{ width: "70%", textAlign: "left" }}
            >
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <li
                    style={{
                      padding: "5px",
                      margin: "2px",
                    }}
                    key={option.value}
                    className="dropdown-item"
                    onClick={() => handleSelect(option.value)}
                  >
                    {option.label}
                  </li>
                ))
              ) : (
                <li className="dropdown-item no-results">No results found</li>
              )}
            </ul>
          )}
        </div>
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}
        {loading && <div className="loading-message">Loading...</div>}
      </div>
    );
  };

  const [formData, setFormData] = useState({
    vehicle_id: "",
    vehicle_reg_no: "",
    vehicle_reg_name: "",
    brand_id: "",
    model_id: "",
    sub_model_id: "",
    vehicle_type_id: "",
    fuel_type_id: "1",
    vehicle_reg_date: "",
    vehicle_reg_valid_till: "",
    vehicle_engine_no: "",
    vehicle_chassis_no: "",
    vehicle_colour_name: "",
    vehicle_tyre_size: "",
    vehicle_battery_type: "",
    vehicle_puc_start_date: "",
    vehicle_puc_end_date: "",
    vehicle_cng_start_date: "",
    vehicle_cng_end_date: "",
    customer_id: "",
  });

  const [files, setFiles] = useState({
    vehicle_side1_image: null,
    vehicle_side2_image: null,
    vehicle_front_image: null,
    vehicle_back_image: null,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [subModels, setSubModels] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [modelLoading, setModelLoading] = useState(false);
  const [subModelLoading, setSubModelLoading] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);

  // Populate form with vehicle data when component loads
  useEffect(() => {
    if (vehicleData) {
      setFormData({
        vehicle_id: vehicleData.vehicle_id || "",
        vehicle_reg_no: vehicleData.vehicle_reg_no || "",
        vehicle_reg_name: vehicleData.vehicle_reg_name || "",
        brand_id: vehicleData.brand_id || "",
        model_id: vehicleData.model_id || "",
        sub_model_id: vehicleData.sub_model_id || "",
        vehicle_type_id: vehicleData.vehicle_type_id || "",
        fuel_type_id: vehicleData.fuel_type_id || "1",
        vehicle_reg_date: vehicleData.vehicle_reg_date || "",
        vehicle_reg_valid_till: vehicleData.vehicle_reg_valid_till || "",
        vehicle_engine_no: vehicleData.vehicle_engine_no || "",
        vehicle_chassis_no: vehicleData.vehicle_chassis_no || "",
        vehicle_colour_name: vehicleData.vehicle_colour_name || "",
        vehicle_tyre_size: vehicleData.vehicle_tyre_size || "",
        vehicle_battery_type: vehicleData.vehicle_battery_type || "",
        vehicle_puc_start_date: vehicleData.vehicle_puc_start_date || "",
        vehicle_puc_end_date: vehicleData.vehicle_puc_end_date || "",
        vehicle_cng_start_date: vehicleData.vehicle_cng_start_date || "",
        vehicle_cng_end_date: vehicleData.vehicle_cng_end_date || "",
        customer_id: vehicleData.customer_id || "",
      });

      // Fetch customer details
      if (vehicleData.customer_id) {
        fetchCustomerDetails(vehicleData.customer_id);
      }
    }
  }, [vehicleData]);

  // Fetch customer details
  const fetchCustomerDetails = async (customerId) => {
    setCustomerLoading(true);
    try {
      const customerFormData = new URLSearchParams();
      customerFormData.append("company_id", company_id);
      customerFormData.append("customer_id", customerId);
      customerFormData.append("customer_grage_id", grage_id || "");
      customerFormData.append("searh_text", "");
      const customerResponse = await axios.post(
        `${server_url}customer.php`,
        customerFormData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (
        customerResponse.data.status == "1" &&
        customerResponse.data.result &&
        customerResponse.data.result.length > 0
      ) {
        setCustomerData(customerResponse.data.result[0]);
      }
    } catch (error) {
      console.error("Fetch customer details error:", error);
    } finally {
      setCustomerLoading(false);
    }
  };

  // Fetch brands, vehicle types, fuel types
  useEffect(() => {
    const fetchBrands = async () => {
      if (!server_url || !company_id) return;
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        const response = await axios.post(
          `${server_url}brand.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const brandOptions = (response.data.result || []).map((brand) => ({
            value: brand.brand_id,
            label: brand.brand_name,
          }));
          setBrands(brandOptions);
        } else {
          setBrands([]);
        }
      } catch (error) {
        console.error("Fetch brands error:", error);
        setBrands([]);
      }
    };
    const fetchVehicleTypes = async () => {
      if (!server_url || !company_id) return;
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        const response = await axios.post(
          `${server_url}vehicle_type.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const typeOptions = (response.data.result || []).map((type) => ({
            value: type.vehicle_type_id,
            label: type.vehicle_type_name,
          }));
          setVehicleTypes(typeOptions);
        } else {
          setVehicleTypes([]);
        }
      } catch (error) {
        console.error("Fetch vehicle types error:", error);
        setVehicleTypes([]);
      }
    };
    const fetchFuelTypes = async () => {
      if (!server_url || !company_id) return;
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        const response = await axios.post(
          `${server_url}fuel_type.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const fuelOptions = (response.data.result || []).map((fuel) => ({
            value: fuel.fuel_type_id,
            label: fuel.fuel_type_name,
          }));
          setFuelTypes(fuelOptions);
        } else {
          setFuelTypes([]);
        }
      } catch (error) {
        console.error("Fetch fuel types error:", error);
        setFuelTypes([]);
      }
    };
    fetchBrands();
    fetchVehicleTypes();
    fetchFuelTypes();
  }, [server_url, company_id]);

  // Fetch models when brand_id changes
  useEffect(() => {
    const fetchModels = async () => {
      if (!formData.brand_id || !company_id) {
        setModels([]);
        setSubModels([]);
        return;
      }
      setModelLoading(true);
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        formDataToSend.append("brand_id", formData.brand_id);
        const response = await axios.post(
          `${server_url}model.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const modelOptions = (response.data.result || []).map((model) => ({
            value: model.model_id,
            label: model.model_name,
          }));
          setModels(modelOptions);
        } else {
          setModels([]);
        }
      } catch (error) {
        console.error("Fetch models error:", error);
        setModels([]);
      } finally {
        setModelLoading(false);
      }
    };
    fetchModels();
  }, [formData.brand_id, server_url, company_id]);

  // Fetch sub models when model_id changes
  useEffect(() => {
    const fetchSubModels = async () => {
      if (!formData.model_id || !company_id) {
        setSubModels([]);
        return;
      }
      setSubModelLoading(true);
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        formDataToSend.append("model_id", formData.model_id);
        const response = await axios.post(
          `${server_url}sub_model.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const subModelOptions = (response.data.result || []).map((sub) => ({
            value: sub.sub_model_id,
            label: sub.sub_model_name,
          }));
          setSubModels(subModelOptions);
        } else {
          setSubModels([]);
        }
      } catch (error) {
        console.error("Fetch sub models error:", error);
        setSubModels([]);
      } finally {
        setSubModelLoading(false);
      }
    };
    fetchSubModels();
  }, [formData.model_id, server_url, company_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newForm = { ...prev, [name]: value };
      if (name == "brand_id") {
        newForm.model_id = "";
        newForm.sub_model_id = "";
      } else if (name == "model_id") {
        newForm.sub_model_id = "";
      }
      return newForm;
    });
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFiles((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.vehicle_reg_no.trim()) {
      newErrors.vehicle_reg_no = "Vehicle plate number is required";
    }
    if (!formData.vehicle_reg_name.trim()) {
      newErrors.vehicle_reg_name = "Vehicle Registration Name is required";
    }
    if (!formData.brand_id) {
      newErrors.brand_id = "Brand is required";
    }
    if (!formData.model_id) {
      newErrors.model_id = "Model is required";
    }

    if (!formData.vehicle_type_id) {
      newErrors.vehicle_type_id = "Vehicle Type is required";
    }
    if (!formData.fuel_type_id) {
      newErrors.fuel_type_id = "Fuel Type is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    try {
      const vehicleFormDataToSend = new FormData();
      vehicleFormDataToSend.append("vehicle_grage_id", grage_id || "");
      vehicleFormDataToSend.append("company_id", company_id);
      vehicleFormDataToSend.append("customer_id", formData.customer_id);
      vehicleFormDataToSend.append("vehicle_id", formData.vehicle_id);
      vehicleFormDataToSend.append("brand_id", formData.brand_id || "");
      vehicleFormDataToSend.append(
        "vehicle_reg_no",
        formData.vehicle_reg_no || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_reg_name",
        formData.vehicle_reg_name || ""
      );
      vehicleFormDataToSend.append("model_id", formData.model_id || "");
      vehicleFormDataToSend.append("sub_model_id", formData.sub_model_id || "");
      vehicleFormDataToSend.append(
        "vehicle_type_id",
        formData.vehicle_type_id || ""
      );
      vehicleFormDataToSend.append("fuel_type_id", formData.fuel_type_id || "");
      vehicleFormDataToSend.append(
        "vehicle_reg_date",
        formData.vehicle_reg_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_reg_valid_till",
        formData.vehicle_reg_valid_till || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_engine_no",
        formData.vehicle_engine_no || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_chassis_no",
        formData.vehicle_chassis_no || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_colour_name",
        formData.vehicle_colour_name || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_tyre_size",
        formData.vehicle_tyre_size || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_battery_type",
        formData.vehicle_battery_type || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_puc_start_date",
        formData.vehicle_puc_start_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_puc_end_date",
        formData.vehicle_puc_end_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_cng_start_date",
        formData.vehicle_cng_start_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_cng_end_date",
        formData.vehicle_cng_end_date || ""
      );
      if (files.vehicle_side1_image) {
        vehicleFormDataToSend.append(
          "vehicle_side1_image",
          files.vehicle_side1_image
        );
      }
      if (files.vehicle_side2_image) {
        vehicleFormDataToSend.append(
          "vehicle_side2_image",
          files.vehicle_side2_image
        );
      }
      if (files.vehicle_front_image) {
        vehicleFormDataToSend.append(
          "vehicle_front_image",
          files.vehicle_front_image
        );
      }
      if (files.vehicle_back_image) {
        vehicleFormDataToSend.append(
          "vehicle_back_image",
          files.vehicle_back_image
        );
      }

      const vehicleResponse = await axios.post(
        `${server_url}update_vehicle.php`,
        vehicleFormDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (vehicleResponse.data.status == "0") {
        toast.error(vehicleResponse.data.error);
      } else {
        toast.success("Vehicle updated successfully!");
        navigate("/vehicles", { replace: true });
      }
    } catch (error) {
      console.error("Update vehicle error:", error);
      toast.error("Unable to update vehicle. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Handle edit customer
  const handleEditCustomer = () => {
    if (customerData) {
      navigate("/edit-customer", { state: { customer: customerData } });
    }
  };

  if (!vehicleData) {
    return (
      <div className="login-container">
        <div className="login-form-container">
          <div style={{ textAlign: "center", padding: "40px" }}>
            <h3>No vehicle data found</h3>
            <p>Please go back and select a vehicle to edit.</p>
            <Link
              to="/vehicles"
              style={{ color: "#667eea", textDecoration: "none" }}
            >
              <i className="fas fa-arrow-left"></i> Back to Vehicles
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form-wrapper">
          {/* Customer Details Section at Top */}
          <div
            style={{
              marginBottom: "10px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              padding: "15px",
              borderLeft: "4px solid #0352a1",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <h4 style={{ margin: 0, color: "#2d3748", fontSize: "16px" }}>
                <i className="fas fa-user" style={{ marginRight: "8px" }}></i>
                Customer Details
              </h4>
            </div>

            {customerLoading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  color: "#666",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    border: "2px solid #f3f3f3",
                    borderTop: "2px solid #0352a1",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 5px",
                  }}
                ></div>
                Loading customer details...
              </div>
            ) : customerData ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                {/* Customer Name */}
                <div
                  onClick={handleEditCustomer}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <i
                    className="fas fa-user-circle"
                    style={{
                      color: "#0352a1",
                      fontSize: "16px",
                      minWidth: "20px",
                    }}
                  ></i>
                  <div>
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "#2d3748",
                      }}
                    >
                      {customerData.customer_name || "N/A"}
                    </div>
                  </div>
                </div>

                {/* Customer Mobile */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <i
                    className="fas fa-phone"
                    style={{
                      color: "#0352a1",
                      fontSize: "14px",
                      minWidth: "20px",
                    }}
                  ></i>

                  <a
                    href={`tel:${customerData.customer_mobile}`}
                    style={{
                      fontSize: "13px",
                      color: "#4a5568",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                  >
                    {customerData.customer_mobile || "N/A"}
                  </a>
                </div>

                {/* Customer Area */}
                {customerData.customer_area && (
                  <div
                    onClick={handleEditCustomer}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="fas fa-map-marker-alt"
                      style={{
                        color: "#0352a1",
                        fontSize: "14px",
                        minWidth: "20px",
                      }}
                    ></i>
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#4a5568",
                        wordBreak: "break-word",
                      }}
                    >
                      {customerData.customer_area}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  color: "#666",
                  background: "#f1f5f9",
                  borderRadius: "8px",
                }}
              >
                <div style={{ fontSize: "20px", marginBottom: "5px" }}>👤</div>
                <div style={{ fontSize: "12px" }}>
                  Customer details not available
                </div>
              </div>
            )}
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            {/* Vehicle Plate Number (Disabled) */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Plate Number
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-car"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_reg_no"
                  className="form-input"
                  value={formData.vehicle_reg_no}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Vehicle Registration Name */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Registration Name *
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-file-signature"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_reg_name"
                  className={`form-input ${
                    errors.vehicle_reg_name ? "error" : ""
                  }`}
                  placeholder="Vehicle Registration Name"
                  value={formData.vehicle_reg_name}
                  onChange={handleChange}
                  required
                />
              </div>
              {errors.vehicle_reg_name && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.vehicle_reg_name}
                </div>
              )}
            </div>

            {/* Brand */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Brand *
              </label>
              <SearchableDropdown
                name="brand_id"
                options={brands}
                value={formData.brand_id}
                onChange={handleChange}
                placeholder="Select Brand"
                error={errors.brand_id}
                loading={false}
                required
              />
            </div>

            {/* Model */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Model *
              </label>
              <SearchableDropdown
                name="model_id"
                options={models}
                value={formData.model_id}
                onChange={handleChange}
                placeholder="Select Model"
                error={errors.model_id}
                loading={modelLoading}
                disabled={!formData.brand_id}
                required
              />
            </div>

            {/* Sub Model */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Sub Model
              </label>
              <SearchableDropdown
                name="sub_model_id"
                options={subModels}
                value={formData.sub_model_id}
                onChange={handleChange}
                placeholder="Select Sub Model"
                // error={errors.sub_model_id}
                loading={subModelLoading}
                disabled={!formData.model_id}
              />
            </div>

            {/* Vehicle Type */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Type *
              </label>
              <SearchableDropdown
                name="vehicle_type_id"
                options={vehicleTypes}
                value={formData.vehicle_type_id}
                onChange={handleChange}
                placeholder="Select Vehicle Type"
                error={errors.vehicle_type_id}
                loading={false}
                required
              />
            </div>

            {/* Fuel Type */}
            {/* Fuel Type as Radio Buttons */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Fuel Type *
              </label>
              <div
                className="radio-group"
                style={{ display: "flex", gap: "10px", marginTop: "10px" }}
              >
                {fuelTypes.map((fuel) => (
                  <div
                    key={fuel.value}
                    className="radio-option"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      type="radio"
                      id={`fuel_type_${fuel.value}`}
                      name="fuel_type_id"
                      value={fuel.value}
                      checked={formData.fuel_type_id == fuel.value}
                      onChange={handleChange}
                      style={{ marginRight: "4px" }}
                      required
                    />
                    <label
                      htmlFor={`fuel_type_${fuel.value}`}
                      style={{ cursor: "pointer", marginBottom: "0px" }}
                    >
                      {fuel.label}
                    </label>
                  </div>
                ))}
              </div>
              {errors.fuel_type_id && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.fuel_type_id}
                </div>
              )}
            </div>

            {/* Vehicle Engine No */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Engine No
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-cog"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_engine_no"
                  className="form-input"
                  placeholder="Engine Number"
                  value={formData.vehicle_engine_no}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Vehicle Chassis No */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Chassis No
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-barcode"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_chassis_no"
                  className="form-input"
                  placeholder="Chassis Number"
                  value={formData.vehicle_chassis_no}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Vehicle Colour */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Colour
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-palette"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_colour_name"
                  className="form-input"
                  placeholder="Vehicle Colour"
                  value={formData.vehicle_colour_name}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Registration Date */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Registration Date
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <input
                  type="date"
                  name="vehicle_reg_date"
                  className="form-input"
                  placeholder="Registration Date"
                  value={formData.vehicle_reg_date}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Registration Valid Till */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Registration Valid Till
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-calendar-check"></i>
                </div>
                <input
                  type="date"
                  name="vehicle_reg_valid_till"
                  className="form-input"
                  placeholder="Registration Valid Till"
                  value={formData.vehicle_reg_valid_till}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Vehicle Left Side */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Left Side
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_side1_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*,application/pdf"
                />
              </div>
            </div>

            {/* Vehicle Right Side */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Right Side
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_side2_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*,application/pdf"
                />
              </div>
            </div>

            {/* Vehicle Front Image */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Front Image
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-camera"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_front_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>

            {/* Vehicle Back Image */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Back Image
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-camera"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_back_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="login-button"
              disabled={loading}
              onClick={(e) => {
                // Explicitly call handleSubmit
                handleSubmit(e);
              }}
            >
              <i className="fas fa-save"></i>
              {loading ? "Updating..." : "Update Vehicle"}
            </button>
          </form>
        </div>
      </div>

      <style jsx>{`
        .radio-group {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          margin-top: 8px;
        }

        .radio-option {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .radio-option input[type="radio"] {
          width: 18px;
          height: 18px;
          margin-right: 8px;
          cursor: pointer;
        }

        .radio-option label {
          cursor: pointer;
          user-select: none;
          font-size: 14px;
          color: #333;
        }

        /* For error state */
        .radio-group.error {
          border: 1px solid #dc3545;
          padding: 10px;
          border-radius: 5px;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default EditVehicle;
